import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { ACTION, ACTION_SUBJECT, ACTION_SUBJECT_ID, EVENT_TYPE } from '@atlaskit/editor-common/analytics';
import { linkMessages } from '@atlaskit/editor-common/messages';
import { FloatingToolbarButton as Button } from '@atlaskit/editor-common/ui';
import PanelRightIcon from '@atlaskit/icon/core/panel-right';
import { useSmartLinkContext } from '@atlaskit/link-provider';
import { Inline, Box, Flex } from '@atlaskit/primitives/compiled';
import { getObjectAri, getObjectIconUrl, getObjectName } from '@atlaskit/smart-card';
import { getResolvedAttributesFromStore } from '../../pm-plugins/utils';
import { appearanceForLink } from '../analytics/utils';
export var OpenPreviewPanelToolbarButton = function OpenPreviewPanelToolbarButton(_ref) {
  var node = _ref.node,
    intl = _ref.intl,
    areAnyNewToolbarFlagsEnabled = _ref.areAnyNewToolbarFlagsEnabled,
    editorAnalyticsApi = _ref.editorAnalyticsApi,
    editorView = _ref.editorView;
  var _useSmartLinkContext = useSmartLinkContext(),
    store = _useSmartLinkContext.store,
    isPreviewPanelAvailable = _useSmartLinkContext.isPreviewPanelAvailable,
    openPreviewPanel = _useSmartLinkContext.openPreviewPanel;
  var url = node.attrs.url;
  var display = appearanceForLink(node);
  var cardState = store === null || store === void 0 ? void 0 : store.getState()[url];
  if (cardState) {
    var ari = getObjectAri(cardState.details);
    var name = getObjectName(cardState.details);
    var iconUrl = getObjectIconUrl(cardState.details);
    var isPanelAvailable = ari && (isPreviewPanelAvailable === null || isPreviewPanelAvailable === void 0 ? void 0 : isPreviewPanelAvailable({
      ari: ari
    }));
    var handleOpenGlancePanelClick = function handleOpenGlancePanelClick() {
      if (openPreviewPanel && isPanelAvailable) {
        openPreviewPanel({
          url: url,
          ari: ari,
          name: name || '',
          iconUrl: iconUrl
        });
      }
      editorAnalyticsApi === null || editorAnalyticsApi === void 0 || editorAnalyticsApi.fireAnalyticsEvent({
        action: ACTION.CLICKED,
        actionSubject: ACTION_SUBJECT.SMART_LINK,
        actionSubjectId: ACTION_SUBJECT_ID.TOOLBAR_PREVIEW,
        attributes: _objectSpread({
          previewType: 'panel'
        }, getResolvedAttributesFromStore(url, display, store)),
        eventType: EVENT_TYPE.UI
      });
    };
    var title = intl.formatMessage(linkMessages.openPreviewPanel);
    var icon = areAnyNewToolbarFlagsEnabled ? /*#__PURE__*/React.createElement(PanelRightIcon, {
      label: "",
      spacing: "spacious"
    }) :
    /*#__PURE__*/
    // This is a hack required for Jira until areToolbarFlagsEnabled are enabled to ensure the icon has padding
    // Padding is removed when areToolbarFlagsEnabled for a button with icon only in platform/packages/editor/editor-common/src/ui/FloatingToolbar/Button.tsx
    React.createElement(Inline, {
      as: "span",
      space: "space.050",
      alignBlock: "center"
    }, /*#__PURE__*/React.createElement(Box, {
      as: "span",
      "aria-hidden": true,
      role: "presentation"
    }), /*#__PURE__*/React.createElement(PanelRightIcon, {
      label: "",
      spacing: "spacious"
    }), /*#__PURE__*/React.createElement(Box, {
      as: "span",
      "aria-hidden": true,
      role: "presentation"
    }));
    if (openPreviewPanel && isPanelAvailable) {
      return /*#__PURE__*/React.createElement(Flex, {
        gap: "space.050"
      }, /*#__PURE__*/React.createElement(Button, {
        testId: "open-preview-panel-floating-toolbar-button",
        onClick: handleOpenGlancePanelClick,
        icon: icon,
        title: title,
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
      }));
    }
  }
  return null;
};